import { useQueryClient } from '@tanstack/react-query'
import { useRealtime } from '@/lib/ws/useRealtime'
import { projectKeys } from './api'

export function ProjectsRealtime() {
  const qc = useQueryClient()
  useRealtime(
    // Atama, durum değişikliği ve yorum bildirimleri görev ekranlarını da tazeler.
    (event) => event.startsWith('task.'),
    () => {
      void qc.invalidateQueries({ queryKey: projectKeys.all })
    },
  )
  return null
}
